
import { mapGetters } from "vuex";
import VueSelect from "vue-select";
import TableApp from "@/components/Table/Table3.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import PlusIcon from "vue-material-design-icons/Plus.vue";
import _ from "lodash";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import { mapActions } from "vuex";

import { SistemaMixin } from "@/modules/Application";

export default {
  name: "app-tributacao-create",
  components: {
    VueSelect,
    TableApp,
    TrashCanIcon,
    PlusIcon,
    Money,
  },
  data() {
    return {
      form: {
        aliquota_simples: 0,
      },
      configTaxa: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 4,
        masked: false,
      },
      cstSelected: null,
      configMask: settingMoney,
      tabIndex: 0,
      render: 0,
      cstcofinsOptions: [],
      tributacaoTipos: [],
      tributacao: null,
      exigibilidade: null,
      exigibilidadeTipos: [],
      regras: [],
      municipioSelected: null,
      municipioToAdd: {
        aliquota_iss: null,
        retencao_iss: null,
      },
      tipo_imunidade: null,
      municipiosOptions: [],
      fields: [
        {
          label: "Município",
          field: "cidade",
          slot: true,
          sortable: false,
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "% ISS",
          field: "aliquota_iss",
          slot: true,
          sortable: false,
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "% Retenção de ISS",
          field: "retencao_iss",
          slot: true,
          sortable: false,
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "",
          field: "actions",
          sortable: false,
          width: "15%",
          slot: true,
        },
      ],
      tipoImunidade: [
        {
          'codigo': 0,
          'descricao': '0 - Imunidade (tipo não informado na nota de origem)'
        },
        {
          'codigo': 1,
          'descricao': '1 - Imunidade (tipo não informado na nota de origem)'
        },
        {
          'codigo': 2,
          'descricao': '2 - Templos de qualquer culto'
        },
        {
          'codigo': 3,
          'descricao': '3 - Patrimônio, renda ou serviços dos partidos políticos, inclusive suas fundações ...'
        },
        {
          'codigo': 4,
          'descricao': '4 - Livros, jornais, periódicos e o papel destinado a sua impressão'
        },
        {
          'codigo': 5,
          'descricao': '5 - Fonogramas e videofonogramas musicais produzidos no Brasil contendo obras musicais ou literomusicais de autores brasileiros ....'
        },
      ]
    };
  },

  mixins: [SistemaMixin],
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      event.target.classList.add("active");
    },
    setCst(value) {
      this.form.cst_cofins = value.codigo;
      this.cstSelected = value;
    },
    addMunicipioISS() {
      this.regras.push({
        cidade:
          this.municipioSelected.cidade + " - " + this.municipioSelected.uf,
        id_cidade: this.municipioSelected.id_cidade,
        aliquota_iss: this.municipioToAdd.aliquota_iss,
        retencao_iss: this.municipioToAdd.retencao_iss,
      });
      this.municipioSelected = null;
      this.municipioToAdd.aliquota_iss = null;
      this.municipioToAdd.retencao_iss = null;
      this.$bvModal.hide("modal-iss-cidade");
    },
    handleDeleteIss(data) {
      this.regras = this.regras.filter(
        (regra) => regra.id_cidade !== data.id_cidade
      );
    },
    onSearchMunicipio(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.searchMunicipio(loading, search, this);
      }
    },
    searchMunicipio: _.debounce(async (loading, search, vm) => {
      const response = await vm.$http.post("/tributacaoservico/get-cidade", {
        cidade: search,
      });
      vm.municipiosOptions.splice(
        0,
        vm.municipiosOptions.length,
        ...response.data
      );
      loading(false);
    }, 500),

    async getDataInit() {
      this.setLoading(true);
      const responseTributacao = await this.$http.post(
        "/tributacaoservico/get-tipos-tributacao"
      );
      const responseExigibilidadeTipos = await this.$http.post(
        "/tributacaoservico/get-exigibilidade-tributacao"
      );
      this.tributacaoTipos = responseTributacao.data;
      this.exigibilidadeTipos = responseExigibilidadeTipos.data;
      this.cstcofinsOptions = await this.getCSTCofinsByCodigo();
      this.setCst({
        codigo: "99",
        descricao: "Outras Operações",
        id_cstcofins: 11
      })

      if (!_.isEmpty(this.$route.params)) {
        const tributacaoData = this.$route.params.tributacaoData;
        this.form = { ...tributacaoData };
        this.form.base_pis_cofins = this.numberToReal(
          this.form.base_pis_cofins,
          this.configMask.precision
        );
        this.form.aliquota_pis = this.numberToReal(
          this.form.aliquota_pis,
          this.configMask.precision
        );
        this.form.aliquota_cofins = this.numberToReal(
          this.form.aliquota_cofins,
          this.configMask.precision
        );
        this.form.retencao_cofins = this.numberToReal(
          this.form.retencao_cofins
        );
        this.form.retencao_cpp = this.numberToReal(this.form.retencao_cpp);
        this.form.retencao_csll = this.numberToReal(this.form.retencao_csll);
        this.form.retencao_irrf = this.numberToReal(this.form.retencao_irrf);
        this.form.retencao_inss = this.numberToReal(this.form.retencao_inss);
        this.form.retencao_pis = this.numberToReal(this.form.retencao_pis);
        this.form.aliquota_ibpt = this.numberToReal(this.form.aliquota_ibpt);
        this.form.aliquota_simples = this.numberToReal(
          this.form.aliquota_simples,
          this.configMask.precision
        );
        this.form.versao_rtc = this.form.versao_rtc;
        this.regras = tributacaoData.tributacao_servico_cidade.map((item) => ({
          ...item,
          cidade: item.cidade.cidade + " - " + item.cidade.uf,
        }));
        this.tributacao = tributacaoData.tipoTributacao;
        this.exigibilidade = tributacaoData.exigibilidade;
        this.form.tipo_imunidade = tributacaoData.tipo_imunidade;
        this.cstSelected = this.cstcofinsOptions.find(
          (option) => option.codigo == tributacaoData.cst_cofins
        );
        this.render++;
      }
      this.setLoading(false);
    },
    async onSubmit() {
      this.addLoadingToButton("submit_nova_tributacao");
      const dataToSave = {
        ...this.form,
        tipoTributacao: this.tributacao,
        exigibilidade: this.exigibilidade,
        regras: this.regras,
      };
      try {
        if (!_.isEmpty(this.$route.params)) {
          await this.$http.post("/tributacaoservico/update", dataToSave);
          this.$toast.success("Tributação atualizada com sucesso!");
        } else {
          await this.$http.post("/tributacaoservico/create", dataToSave);
          this.$toast.success("Tributação salva com sucesso!");
        }
        this.$router.push({ name: "tributacoesServicos" });
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("submit_nova_tributacao");
    },
  },
  created() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
};
